import { render, staticRenderFns } from "./QuestionSection.vue?vue&type=template&id=01c4b9ff&"
import script from "./QuestionSection.vue?vue&type=script&lang=ts&"
export * from "./QuestionSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports